// import gqmsUtils from '@/views/gqmsCommUtil/api'; //공통함수 import
import { rootComputed } from '@/store/common/helpers';
import { setLpad, setChartBgColor, setChartBdColor } from '@/qmsUtils/'; //공통함수 import
import moment from 'moment';

export default {
	dayCols_: (state, getters, rootState, rootGetters) => {
		let cols = [];
		let selectYear = state.searchParams.useTerm;
		let startYear = moment().subtract(selectYear, 'Y').format('YYYY');
		let endYear = moment().format('YYYY');

		let partNo = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC000956')}`, //품번
			prop: 'partNo',
			align: 'left',
			width: '180px',
			sortable: false
		};
		let partNm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001141')}`, //품명
			prop: 'partNm',
			align: 'left',
			width: '300px',
			sortable: false
		};
		let phmnCd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001055')}`, //현상코드
			prop: 'phmnCd',
			align: 'left',
			minWidth: '300px',
			sortable: false
		};
		let phmnNm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001070')}`, //현상코드명
			prop: 'phmnNm',
			align: 'left',
			minWidth: '300px',
			sortable: false
		};
		let totalCnt ={
			label: `${rootGetters['commonStore/getMessage_']('QWCC001569')}`, //총건수
			prop: 'totalCnt',
			width: '200px',
			align: 'center',
			sortable: false
		};
		let newCol1 = {
			// 건수기준
			label: `${rootGetters['commonStore/getMessage_']('QWCC001649')}`,
			width: '600px',
			align: 'center',
			sortable: false,
			children: [
				{
					label: `${rootGetters['commonStore/getMessage_']('QWCC001568')}`, //총건수
					prop: 'totCnt',
					width: '200px',
					align: 'center',
					sortable: false
				},
				
				// {
				// 	label: `${rootGetters['commonStore/getMessage_']('QWCC001651')}`, //교체수
				// 	prop: 'chngCnt',
				// 	width: '200px',
				// 	align: 'right',
				// 	sortable: false
				// },
				 {
					label: `${rootGetters['commonStore/getMessage_']('QWCC001234')}`, //불량율
					prop: 'partCnt',
					width: '200px',
					align: 'center',
					sortable: false
				}
			]
		};
		let newCol2 = {
			// 금액기준
			label: `${rootGetters['commonStore/getMessage_']('QWCC001650')}`,
			width: '400px',
			align: 'center',
			sortable: false,
			children: [
				{
					label: `${rootGetters['commonStore/getMessage_']('QWCC001104')}`, //총금액
					prop: 'partSum',
					width: '200px',
					align: 'center',
					sortable: false
				},
				{
					label: `${rootGetters['commonStore/getMessage_']('QWCC001653')}`, //건당
					prop: 'amtCnt',
					width: '200px',
					align: 'center',
					sortable: false
				}
			]
		};

		cols.push(partNo);
		cols.push(partNm);
		cols.push(phmnCd);
		cols.push(phmnNm);
		cols.push(totalCnt);
		cols.push(newCol1);
		cols.push(newCol2);
		return cols;
	}
};
